(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxResizable
	 * @module mx.components
	 * @restrict 'A'
	 * @description
	 * The mx-resizable directive is used to allow some panel be resizable. direction:
	 * Currently support just 'right' and 'left' `directive`.
	 * If `localStorageWidthKey` isn't set then it will not be stored.
	 *
	 * @usage <div mx-resizable="{direction: 'right', localStorageWidthKey: 'mxShellExtraPanelWidth'}"></div>
	 *
	 */

	angular.module('mx.components').directive('mxResizable', function mxResizableDirective() {
		return {
			restrict: 'A',
			controller: MxResizableCtrl,
			bindToController: {
				mxResizable: '<',
			},
		};
	});

	MxResizableCtrl.$inject = ['$element', '$document', '$scope', 'mx.shell.InternationalizationService'];

	function MxResizableCtrl($element, $document, $scope, i18nService) {
		const vm = this;
		const htmlEL = $('html');
		const HALF_DRAGSTRAP_WIDTH = 3;
		const minWidth = 200;
		const isRightToLeftTextMode = i18nService.currentLanguage.isRightToLeft;
		let containerEl;
		let dragStrapEl;
		let enableResizeMode = false;
		let resizePlaceholder;
		let oppositeSideOffset = 0;
		let currentWidth = 300;
		let windowWidth;

		var options = {
			direction: 'right',
			localStorageWidthKey: undefined,
		};

		vm.$onInit = function () {
			$.extend(options, vm.mxResizable);
		};

		vm.$postLink = function () {
			containerEl = $($element);

			currentWidth = (localStorage && options.localStorageWidthKey && parseInt(localStorage.getItem(options.localStorageWidthKey), 10)) || containerEl.width();

			dragStrapEl = $('<div class="mx-resize-drag-strap mx-resize-drag-strap--to-' + options.direction + '" />');
			containerEl.append(dragStrapEl);
			dragStrapEl.on('mousedown', startResize);
			$document.on('mouseup', stopResize);

			setWidth(currentWidth);
		};

		vm.$onDestroy = function () {
			dragStrapEl.remove();
			$document.off('mouseup', stopResize);
		};

		function startResize(event) {
			windowWidth = mx.components.Utils.windowSize().width;
			enableResizeMode = true;
			$document.on('mousemove', handleResize);
			htmlEL.addClass('is-resizing');
			resizePlaceholder = angular.element('<div class="mx-resize-placeholder mx-resize-placeholder--to-' + options.direction + '" />');
			resizePlaceholder.prependTo('body');

			const isLogicalRightDirection = (options.direction === 'right' && !isRightToLeftTextMode) || (options.direction === 'left' && isRightToLeftTextMode);
			const leftOffset = containerEl.offset().left;
			oppositeSideOffset = (isLogicalRightDirection && leftOffset) || (!isLogicalRightDirection && windowWidth - leftOffset - containerEl.width());
			resizePlaceholder.css((options.direction === 'right' && 'inset-inline-start') || (options.direction === 'left' && 'inset-inline-end'), oppositeSideOffset + 'px');

			handleResize(event);
		}

		function handleResize(event) {
			if (!enableResizeMode) {
				return;
			}

			const logicalClientX = isRightToLeftTextMode ? windowWidth - event.clientX : event.clientX;

			currentWidth = Math.max(
				minWidth,
				(options.direction === 'right' && logicalClientX - oppositeSideOffset - HALF_DRAGSTRAP_WIDTH) ||
					(options.direction === 'left' && windowWidth - logicalClientX - oppositeSideOffset + HALF_DRAGSTRAP_WIDTH)
			);
			resizePlaceholder.width(currentWidth + (options.direction === 'right' ? 2 * HALF_DRAGSTRAP_WIDTH : 0));
		}

		function stopResize() {
			if (!enableResizeMode) {
				return;
			}
			enableResizeMode = false;
			$document.off('mousemove', handleResize);
			if (localStorage && options.localStorageWidthKey) {
				localStorage.setItem(options.localStorageWidthKey, currentWidth);
			}
			htmlEL.removeClass('is-resizing');
			resizePlaceholder.remove();
			setWidth(currentWidth);
			if (options.onChange) {
				options.onChange();
			}
		}

		function setWidth(width) {
			$scope.$evalAsync(function () {
				containerEl.width(width);
			});
		}
	}
})();
